const MemberAccountReportTypes = {
	/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS START *********************** */
	GET_MEMBER_ACCOUNT_REPORT_SAVINGS_START: 'get_member_account_report_savings_start',
	GET_MEMBER_ACCOUNT_REPORT_SAVINGS_SUCCESS: 'get_member_account_report_savings_success',
	GET_MEMBER_ACCOUNT_REPORT_SAVINGS_FAILURE: 'get_member_account_report_savings_failure',
	GET_MEMBER_ACCOUNT_REPORT_SAVINGS_RESPONSE_RESET:
		'get_member_account_report_savings_response_reset',
	GET_MEMBER_ACCOUNT_REPORT_SAVINGS_RESPONSE_CHANGED:
		'get_member_account_report_savings_response_changed',
	/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS END *********************** */

	/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT START *********************** */
	GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_START: 'get_member_account_report_fixed_deposit_start',
	GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_SUCCESS:
		'get_member_account_report_fixed_deposit_success',
	GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_FAILURE:
		'get_member_account_report_fixed_deposit_failure',
	GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_RESPONSE_RESET:
		'get_member_account_report_fixed_deposit_response_reset',
	GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_RESPONSE_CHANGED:
		'get_member_account_report_fixed_deposit_response_changed',
	/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT END *********************** */
};
export default MemberAccountReportTypes;
